import React, { useMemo } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import "react-phone-input-2/lib/style.css";
// css
import { useNavigate, useParams, Link, generatePath } from "react-router-dom";
import { successMessageToast } from "helpers/common";
import { SCHOOL_BANNERS_EDIT, SCHOOL_BANNERS_LIST, THERAPIST_LIST } from "config/paths";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { Breadcrumbs } from "components/Common/Common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useCreateSchoolBannerMutation, useUpdateSchoolBannerMutation, useViewSchoolBannerQuery } from "store/services/schoolBanners";
import { ChevronLeft, ChevronRight } from "react-feather";

const ViewSchoolBanner = () => {
  const { id } = useParams();
  
  const {
    data: bannerData,
    isLoading: getSchoolBannerLoading,
    isError: getSchoolBannerError,
  } = useViewSchoolBannerQuery({ id }, { skip: !id });

  const breadcrumbItems = [
    { label: "School Banners", path: SCHOOL_BANNERS_LIST },
    { label: "Edit Banner", path: generatePath(SCHOOL_BANNERS_EDIT, { id }) },
    { label: "View Banner" },
  ];

  return (
    <>
      {
        getSchoolBannerLoading ? <LoadingIndicator/> : 
        <>
      <section className={` position-relative py-0 addForm`}>
        <Container fluid={true}>
          <Row
            style={{
              width: '100%',
              // maxWidth: window.innerWidth >= 992 ? 'calc(100% - 170px)' : '100%',
              padding: '10px'
            }}
          >
            <Col lg={12} className="mt-2 mb-3">
              <div className="pageHead d-flex align-items-center justify-content-between flex-wrap">
                <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
              </div>
              <div>
                {/* <h3 className="h5 mt-3">{editMode ? "Edit Clinician" : "Add Clinician"}</h3> */}
              </div>
            </Col>

            {/* <Row className="mt-0 g-3">
              {getSchoolBannerLoading ? (
                <LoadingIndicator />
              ) : getSchoolBannerError ? (
                <ErrorComponent />
              ) : (
               
              )}
            </Row> */}
          </Row>
        </Container>

      </section>
      <section className='client position-relative py-4 px-2 min-vh-100' >

        <div
          className="banner-carousel"
        >
          <div className="banner-carousel">
            {/* Background image from API */}
            <div
              className="banner-carousel__bg"
              style={{
                backgroundImage: bannerData?.banner_image ? `url(${bannerData?.banner_image})` : undefined,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />

          



            {/* Content card */}
            <div className="banner-carousel__card">
              <h2>{bannerData?.title}</h2>
              {/* description comes as HTML string from API */}
              <div
                className="banner-carousel__desc"
                dangerouslySetInnerHTML={{ __html: bannerData?.description }}
              />
              {bannerData?.link_url && (
                <a
                  href={bannerData?.link_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="banner-carousel__link"
                >
                  Learn more →
                </a>
              )}
            </div>
          </div>
        </div>
      </section>
      </>
      }
    </>
  );
};

const defaultInitialValues = {
  title: "",
  description: "",
  link_url: "",
  from_date: null,
  to_date: null,
  banner_image: "",
  status: ''
};

export default ViewSchoolBanner;
